<div cdkDropListGroup>

  <!-- Items with no day yet -->
  <div class="unassigned-strip p-2 mb-3"
       cdkDropList cdkDropListSortingDisabled
       [cdkDropListData]="unassignedItems"
       (cdkDropListDropped)="onDroppedToUnassigned($event)">
    <p class="fs-small fw-800 color-gray-500 mb-2">{{'planner.unassigned_items'|translate}}</p>

    <!-- Browsed one lesson at a time, the way the student planner groups them. -->
    <div class="lessons-wrapper d-flex align-items-center flex-wrap gap-2 mb-2 lesson-filter-btn-group"
         *ngIf="lessonFilters.length">
      <a class="filter-btn fw-800 fs-small clickable px-3 py-1" *ngFor="let filter of lessonFilters"
         [class.active]="filter.id === selectedLessonId" (click)="selectLesson(filter.id)">
        {{filter.name || ('planner.other_items'|translate)}}
      </a>
    </div>

    <div class="plan-items d-flex flex-wrap">
      <div class="plan-item me-2 mb-2 p-2" *ngFor="let item of visibleUnassignedItems()"
           cdkDrag [cdkDragData]="item" [cdkDragDisabled]="!config.canEdit">
        <p class="lesson-name color-gray-300 fw-400 fs-small mb-0">
          {{item?.exam?.examKey|uppercase}} {{item?.lesson?.name}}
        </p>
        <p class="subject-name color-gray-950 fw-400 fs-normal mb-0">
          {{item.lessonTopic?.name || item.text || item.video?.title}}
        </p>
      </div>

      <p class="fs-small fw-400 color-gray-300 mb-0" *ngIf="!unassignedItems.length">
        {{'planner.all_items_assigned'|translate}}
      </p>
    </div>
  </div>

  <!-- One column per day of the week -->
  <div class="planner-days-container">
    <div class="card card-day p-0" *ngFor="let day of days"
         cdkDropList cdkDropListSortingDisabled
         [cdkDropListData]="day.items"
         (cdkDropListDropped)="onDroppedToDay($event, day)">

      <div class="d-flex justify-content-between align-items-center p-2 bg-level-primary">
        <p class="color-white fs-normal fw-400 mb-0">{{day.date | date: 'EEEE'}}</p>
        <p class="color-white fs-small fw-400 mb-0">{{day.date | date: 'd MMM'}}</p>
      </div>

      <div class="day-card-body w-100 d-flex flex-column gap-2 p-2 overflow-y-auto">
        <div *ngFor="let item of day.items; let i = index" cdkDrag [cdkDragData]="item"
             [cdkDragDisabled]="!config.canEdit">
          <app-planner-item
            [item]="item" [index]="i" [config]="config" [videoTemplate]="videoTemplate" [menuTemplate]="menuTemplate"
            (toggled)="itemToggled.emit($event)"
            (transferRequested)="itemTransferRequested.emit($event)"
            (duplicateRequested)="itemDuplicateRequested.emit($event)"
            (removeRequested)="itemRemoveRequested.emit($event)"
            (menuOpened)="itemMenuOpened.emit($event)"></app-planner-item>
        </div>
      </div>

    </div>
  </div>

</div>
